import { LIFE_CYCLE_TAGS, TAGS_COLORS } from './ListingTags.constants';
import { ListingTagsProps, ProcessedTag } from './ListingTags.types';

type TagCombination = {
    [key: string]: ProcessedTag;
};

// TODO - The keys of this object should be codes that are coming from the API
const tagCombinations: TagCombination = {
    'Under offer': {
        value: LIFE_CYCLE_TAGS.under_offer,
        color: TAGS_COLORS.LYCHEE
    },
    'Sold subject to contract': {
        value: LIFE_CYCLE_TAGS.sold_subject_to_contract,
        color: TAGS_COLORS.LYCHEE
    },
    'Let agreed': {
        value: LIFE_CYCLE_TAGS.let_agreed,
        color: TAGS_COLORS.LYCHEE
    },
    Let: {
        value: LIFE_CYCLE_TAGS.let,
        color: TAGS_COLORS.LYCHEE
    },
    'Equity loan': {
        value: LIFE_CYCLE_TAGS.equity_loan,
        color: TAGS_COLORS.OCEAN
    },
    'Part buy part rent': {
        value: LIFE_CYCLE_TAGS.part_buy_part_rent,
        color: TAGS_COLORS.OCEAN
    },
    'Shared equity': {
        value: LIFE_CYCLE_TAGS.shared_equity,
        color: TAGS_COLORS.OCEAN
    },
    'Shared ownership': {
        value: LIFE_CYCLE_TAGS.shared_ownership,
        color: TAGS_COLORS.OCEAN
    },
    'Student friendly': {
        value: LIFE_CYCLE_TAGS.student_friendly,
        color: TAGS_COLORS.OCEAN
    },
    Investment: {
        value: LIFE_CYCLE_TAGS.investment,
        color: TAGS_COLORS.OCEAN
    },
    'New build': {
        value: LIFE_CYCLE_TAGS.new_build,
        color: TAGS_COLORS.OCEAN
    },
    'New home': {
        value: LIFE_CYCLE_TAGS.new_home,
        color: TAGS_COLORS.OCEAN
    },
    'Just added': {
        value: LIFE_CYCLE_TAGS.just_added,
        color: TAGS_COLORS.DENIM
    }
};

export const getTags = ({
    tags,
    statusSummary
}: ListingTagsProps): Array<ProcessedTag> => {
    const processedTags: Array<ProcessedTag> = [];

    statusSummary &&
        statusSummary.label &&
        processedTags.push(
            tagCombinations[statusSummary.label] || {
                value: statusSummary.label
            }
        );

    tags &&
        tags.length > 0 &&
        tags.forEach((tag) =>
            processedTags.push(
                tagCombinations[tag.label] || { value: tag.label }
            )
        );

    return processedTags;
};
